import { render, staticRenderFns } from "./BeVenueAbout.vue?vue&type=template&id=416e4a94&scoped=true"
import script from "./BeVenueAbout.vue?vue&type=script&lang=js"
export * from "./BeVenueAbout.vue?vue&type=script&lang=js"
import style0 from "./BeVenueAbout.vue?vue&type=style&index=0&id=416e4a94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416e4a94",
  null
  
)

export default component.exports